"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "labro": {
    "7b595d00": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "case-tolla": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9de5684": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "colle-del-lupo": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7064357": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "colle-rucciolo": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43bd554e": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "colle-sorbo": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20851a2a": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "colle-sterleta": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9c0f976": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "collelungo": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de67ffa3": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "collicelle": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fa5e1c2": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "macchie-basse": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10057451": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "skipSearch": false
    }],
    "valle-avanzana": [{
      "hkey": "7a69ef60",
      "slug": "labro",
      "name": "Labro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;